import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ImportReport } from "@/pages/admin/ImportReport";

const Stat = ({ label, value, testid }) => (
  <div className="rounded-2xl border border-white/10 bg-[#12141A] p-5">
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{label}</p>
    <p className="mt-3 font-display text-3xl font-semibold" data-testid={testid}>{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
  }, []);
  if (!s) return <div className="h-40 animate-pulse rounded-2xl bg-white/5" />;
  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl font-semibold">Dashboard</h1>
      <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Prodotti" value={s.products} testid="stat-products" />
        <Stat label="Visibili" value={s.visible} testid="stat-visible" />
        <Stat label="Esauriti" value={s.out_of_stock} testid="stat-out-of-stock" />
        <Stat label="Categorie" value={s.categories} testid="stat-categories" />
        <Stat label="Ordini" value={s.orders} testid="stat-orders" />
        <Stat label="Ordini pagati" value={s.orders_paid} testid="stat-orders-paid" />
        <Stat label="Richieste aperte" value={s.requests_open} testid="stat-requests-open" />
        <Stat label="Coupon attivi" value={s.coupons} testid="stat-coupons" />
      </div>
      <div className="mt-6 rounded-2xl border border-amber-400/30 bg-amber-400/10 p-4 text-sm text-amber-200" data-testid="payments-status">
        Pagamenti online: <b>{s.payments_enabled ? "ATTIVI" : "NON ATTIVI"}</b> — l'invio di ordini pubblici è bloccato finché Stripe non sarà verificato e collaudato. L'amministratore autenticato può eseguire ordini di prova (modalità test Stripe).
      </div>
      <div className="mt-10">
        <div className="flex items-center justify-between"><h2 className="font-display text-xl font-semibold">Ultima importazione</h2><Link to="/admin/importa" className="text-sm text-[#4D94FF]">Nuova importazione →</Link></div>
        {s.last_import ? <ImportReport job={s.last_import} /> : <p className="mt-4 text-sm text-slate-400">Nessuna importazione effettuata.</p>}
      </div>
    </div>
  );
}
